import { ChangeDetectionStrategy, Component, computed, inject } from "@angular/core";

import { IDatepickerComponent, IDateRange } from "@front/m19-ui";
import { AuthService, UserSelectionService } from "@front/m19-services";
import { toSignal } from "@angular/core/rxjs-interop";
import { DateUtils } from "@front/m19-utils";
import { map, Observable } from "rxjs";
import { TranslocoDirective } from "@jsverse/transloco";
import { DateTime } from "luxon";
import { PeriodComparisonComponent } from "@m19-board/date-range-selector/period-comparison/period-comparison.component";

@Component({
  selector: "app-date-range-selector",
  imports: [IDatepickerComponent, TranslocoDirective, PeriodComparisonComponent],
  templateUrl: "./date-range-selector.component.html",
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DateRangeSelectorComponent {
  private readonly userSelectionService = inject(UserSelectionService);
  private readonly authService = inject(AuthService);

  readonly _user = toSignal(this.authService.user$);
  readonly dateFormat = computed(() => DateUtils.getDateFormatString(this._user()?.locale ?? "en-US"));
  // TODO: in date should be 1 year ago, but temporarily changed to 2 years ago to allow more data for CSV export
  readonly twoYearsAgo = DateTime.utc().minus({ day: 1, years: 2 }).startOf("day");
  readonly selectedDateRange$: Observable<IDateRange> = this.userSelectionService.selectedDateRange$.pipe(
    map((dateRange) => {
      return {
        start: dateRange.start ? dateRange.start.startOf("day") : DateTime.utc().startOf("day"),
        end: dateRange.end.startOf("day"),
      };
    }),
  );
  readonly selectedDateRange = toSignal<IDateRange>(this.selectedDateRange$, { requireSync: true });

  selectDateRange(dateRange: IDateRange | null) {
    if (dateRange && dateRange.start && dateRange.end) {
      this.userSelectionService.setDateRange(dateRange.start, dateRange.end);
    }
  }
}
